<template>
  <div>
    <div v-if="isLoading" class="loading">
      <Loader :loading="isLoading" />
    </div>
    <div v-else id="list" class="wrrapper ">
      <page-heading title="Patient List" border></page-heading>
      <div class="flex align-center">
        <div
          class="flex align-center"
          style="justify-content: flex-end; width: 100%; margin-left: auto;"
        >
          <Select
            class="mr-1"
            placeholder="Filter by"
            :input="handleFilter"
            :options="filterByOptions"
            :value="selectedDoctor"
          />
          <Input
            type="text"
            placeholder="MR_NO"
            @enter="handleSearch"
            id="search"
            v-model="registrationId"
            icon="mdi-magnify"
            :handleSearch="handleSearch"
            :handleReset="handleReset"
            :reset="registrationId"
          />
          <div class="flex align-center cursor ml-2" @click="printReport">
            <img src="../../assets/print-icon.png" alt="print" />
          </div>
          <span
            style="margin-top: 0.2rem; margin-left: 10px;"
            title="Printer Settings"
            ><i
              style="font-size: 1.2rem; cursor: pointer;"
              class="mdi mdi-cog"
              @click="$modal.show('printerSettings')"
            ></i
          ></span>
        </div>
      </div>
      <div class="tabs-container mb-3">
        <div class="tabs">
          <div
            :class="['tab', { active: activeTab === 'today' }]"
            @click="setActiveTab('today')"
          >
            Today <span class="badge">{{ todayList.length }}</span>
          </div>
          <div
            :class="['tab', { active: activeTab === 'yesterday' }]"
            @click="setActiveTab('yesterday')"
          >
            Yesterday <span class="badge">{{ yesterdayList.length }}</span>
          </div>
        </div>
        <div class="tab-content">
          <data-table
            v-if="activeTab === 'today'"
            :cols="columns"
            :rows="todayList"
            :loading="loading"
          >
            <template slot="action" slot-scope="{ actions }">
              <dropdown-menu
                :rowData="actions"
                :handleItemClick="handleItems"
                :items="items"
              />
            </template>
          </data-table>
          <data-table
            v-if="activeTab === 'yesterday'"
            :cols="columns"
            :rows="yesterdayList"
            :loading="loading"
          >
            <template slot="action" slot-scope="{ actions }">
              <dropdown-menu
                :rowData="actions"
                :handleItemClick="handleItems"
                :items="items"
              />
            </template>
          </data-table>
        </div>
      </div>
      <a href="#" ref="element" class="d-none">
        <div style="text-align: center; padding: 1rem;">
          <div v-for="attachment in attachments" :key="attachment.id">
            <strong
              style="
              font-size: 1.2rem;
              line-height: 1rem;
              word-spacing: 0.03em;
              font-weight: 400;
              font-family: sans-serif;
              margin: 1.5rem;
            "
              >Posted At: {{ formatDate(attachment.created_at) }}</strong
            >
            <img
              :src="attachment.path"
              alt="attachment"
              style="
              display: block;
              margin: auto;
              padding: 1rem;
              margin-top: 1rem;
              margin-bottom: 1rem;
            "
              class="newtab-image"
            />
          </div>
        </div>
      </a>
      <modal
        title="Add Attachment"
        para="Drag & drop file or upload here"
        class="attachment-modal"
        name="attachment"
        height="auto"
        width="600"
        :adaptive="true"
      >
        <template v-slot:content>
          <AttachmentUpload @files="handleAttachmentUpload" />
          <Button
            :onClick="handleUpload"
            className="button--primary custom-button ml-auto"
            title="Upload"
            :loader="loading"
          />
        </template>
      </modal>
      <TablePrint
        :registerPatient="laterDiscountDetails && laterDiscountDetails.patient"
        :discount="laterDiscountDetails && laterDiscountDetails.discount"
        :rows="serviceRows"
        :total="totalAmount"
      />
      <modal
        title="Patient Details"
        name="patientDetails"
        class="custom-modal"
        height="auto"
        width="80%"
        :adaptive="true"
      >
        <template v-slot:content>
          <div class="mt-3 form-wrrpper flex flex-wrap mb-base">
            <Input
              class="mb-base mr-4"
              label="Full Name"
              type="text"
              v-model="fullName"
            />
            <Input
              class="mb-base mr-4"
              label="Father/Husband Name"
              type="text"
              v-model="fatherHusband"
            />
            <Input class="mb-base" label="Age-Year" type="text" v-model="age" />
            <Input
              class="mb-base mr-4"
              label="Address"
              type="text"
              v-model="address"
            />
            <Input
              class="mb-base mr-4"
              label="Contact Number"
              type="number"
              v-model="phone"
            />
            <Radio
              class="mb-base"
              outerLabel="Gender"
              type="radio"
              name="custom"
              v-model="userGender"
              :options="options"
            />
            <Select
              class="mb-base datepicker-wrapper mr-4"
              label="Referred By"
              styles="role-select"
              :clearable="false"
              :value="referredBy"
              :input="handlerefferedBy"
              :options="refferedByDoctors"
            />
            <Select
              v-if="alreadyReported === false"
              class="mb-base datepicker-wrapper"
              label="Referred to"
              styles="role-select"
              :clearable="false"
              :value="refferedTo"
              :input="handleRefferedTo"
              :options="refferedDoctor"
            />
          </div>
          <Button
            className="button--primary custom-button"
            title="Update"
            :onClick="updatePatient"
            :loader="isUpdating"
          ></Button>
        </template>
      </modal>
      <modal
        title="Discount"
        name="discountModal"
        class="custom-modal"
        height="auto"
        width="500px"
        :adaptive="true"
      >
        <template v-slot:content>
          <div class="mt-2">
            <Input
              class="mb-base"
              label="Discount Amount"
              type="number"
              v-model="discount"
            />
            <Button
              className="button--primary custom-button"
              title="Discount"
              :onClick="handleDiscount"
              :loader="loading"
            ></Button>
          </div>
        </template>
      </modal>
    </div>
    <div id="rePrintInvoice">
      <PrintTable
        :refferedTo="invoice.refferedTo"
        :registerPatient="invoice"
        invoiceType="rePrintInvoice"
        :rows="invoiceRows"
        :total="invoiceSubtotal"
        :discount="invoiceDiscountAmount"
        :patientGender="invoicePatientGender"
        :invoiceNo="invoiceNo"
        :isOther="printServiceType"
      />
      <PrintTable
        :refferedTo="invoice.refferedTo"
        :registerPatient="invoice"
        invoiceType="rePrintInvoice"
        :rows="invoiceRows"
        :total="invoiceSubtotal"
        :discount="invoiceDiscountAmount"
        :patientGender="invoicePatientGender"
        :invoiceNo="invoiceNo"
        :isOther="printServiceType"
      />
    </div>
    <div id="externalInvoice">
      <ExternalInvoice
        :invoiceNo="invoiceNo"
        :patient="a4PrintPatient || invoice"
        :searchResult="printSearchResult"
        :refferedTo="printRefferedTo"
        :rows="invoiceRows"
        :charges="invoiceSubtotal"
        :isOther="printServiceType"
        :discount="invoiceDiscountAmount"
        :branch_logo="branchLogoUrl"
        :org_logo="bussinessLogoUrl"
        :selectedDiscountType="invoice.panel_name || ''"
        :referredBy="invoice.refferedBy || referredBy || ''"
        :invoiceType="'rePrintInvoice'"
        :showReceiptCopies="!a4PrescriptionOnly"
        :patientGender="invoicePatientGender"
      />
    </div>
    <AppModal
      name="printConfirmation"
      title="Print Selection"
      height="auto"
      width="420"
    >
      <template v-slot:content>
        <div class="print-modal-content">
          <div
            :class="[
              'printer-status-bar',
              printerIsConnected ? 'connected' : 'disconnected'
            ]"
          >
            <span
              :class="[
                'mdi mdi-20px',
                printerIsConnected ? 'mdi-printer-check' : 'mdi-printer-off'
              ]"
            ></span>
            <div class="printer-info">
              <span class="printer-label">{{
                printerIsConnected ? "Ready" : "Not Connected"
              }}</span>
              <span class="printer-name">{{
                printerIsConnected ? printerName : "Connect thermal printer"
              }}</span>
            </div>
            <Button
              v-if="!printerIsConnected"
              title="Connect"
              className="button--primary button--xs"
              :onClick="connectPrinter"
            />
          </div>
          <div class="print-options">
            <p class="options-title">Select copies to print:</p>
            <div
              class="print-option"
              :class="{ selected: printPatientCopy }"
              @click="printPatientCopy = !printPatientCopy"
            >
              <div class="option-icon patient">
                <span class="mdi mdi-account"></span>
              </div>
              <div class="option-text">
                <span class="option-label">Customer Copy</span>
                <span class="option-desc">Receipt for patient</span>
              </div>
              <div class="option-check">
                <span
                  v-if="printPatientCopy"
                  class="mdi mdi-check-circle"
                ></span>
                <span
                  v-else
                  class="mdi mdi-checkbox-blank-circle-outline"
                ></span>
              </div>
            </div>
            <div
              class="print-option"
              :class="{ selected: printOfficialCopy }"
              @click="printOfficialCopy = !printOfficialCopy"
            >
              <div class="option-icon official">
                <span class="mdi mdi-file-document"></span>
              </div>
              <div class="option-text">
                <span class="option-label">{{
                  printServiceType === "Laboratory" ? "Lab Copy" : "Doctor Copy"
                }}</span>
                <span class="option-desc">Official records</span>
              </div>
              <div class="option-check">
                <span
                  v-if="printOfficialCopy"
                  class="mdi mdi-check-circle"
                ></span>
                <span
                  v-else
                  class="mdi mdi-checkbox-blank-circle-outline"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="print-modal-footer">
          <a href="#" @click.prevent="switchToA4" class="a4-link">
            <span class="mdi mdi-file-outline"></span> Use A4 Print
          </a>
          <div class="footer-buttons">
            <button
              class="btn-cancel"
              @click="$modal.hide('printConfirmation')"
            >
              Cancel
            </button>
            <button
              class="btn-print"
              :disabled="
                !printerIsConnected || (!printPatientCopy && !printOfficialCopy)
              "
              @click="executePrint"
            >
              <span class="mdi mdi-printer"></span> Print
            </button>
          </div>
        </div>
      </template>
    </AppModal>
    <AppModal name="a4AfterThermal" title="A4 Print" height="auto" width="420">
      <template v-slot:content>
        <div class="print-modal-content">
          <p class="options-title">
            Thermal print done. Do you want to print the Doctor prescription on
            A4 as well?
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="print-modal-footer">
          <div
            class="footer-buttons"
            style="justify-content: flex-end; width: 100%;"
          >
            <button class="btn-cancel" @click="skipA4AfterThermal">
              Skip
            </button>
            <button class="btn-print" @click="printA4AfterThermal">
              <span class="mdi mdi-file-outline"></span> Print A4
            </button>
          </div>
        </div>
      </template>
    </AppModal>
    <AppModal
      name="printerSettings"
      title="Printer Settings"
      height="auto"
      width="400"
    >
      <template v-slot:content>
        <div class="printer-settings-modal-body">
          <p class="section-title">Select Default Printer</p>
          <div class="printer-grid">
            <div
              class="sel-card"
              :class="{ active: printerType === 'A4' }"
              @click="
                printerType = 'A4';
                savePrinterType();
              "
            >
              <div class="sel-card-icon">
                <span class="mdi mdi-file-document-outline"></span>
              </div>
              <div class="sel-card-content">
                <h6>A4 Printer</h6>
                <p>Standard documents</p>
              </div>
              <div class="sel-card-radio">
                <div class="radio-circle"></div>
              </div>
            </div>
            <div
              class="sel-card"
              :class="{ active: printerType === 'Thermal' }"
              @click="
                printerType = 'Thermal';
                savePrinterType();
              "
            >
              <div class="sel-card-icon">
                <span class="mdi mdi-printer-pos"></span>
              </div>
              <div class="sel-card-content">
                <h6>Thermal Printer</h6>
                <p>Receipt printing</p>
              </div>
              <div class="sel-card-radio">
                <div class="radio-circle"></div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div v-if="printerType === 'Thermal'" class="printer-status-block">
              <div
                class="status-badge"
                :class="
                  printerIsConnected ? 'bg-success-light' : 'bg-warning-light'
                "
              >
                <span
                  :class="[
                    'mdi mr-1',
                    printerIsConnected ? 'mdi-check-circle' : 'mdi-alert-circle'
                  ]"
                ></span>
                {{ printerIsConnected ? "Connected" : "Action Required" }}
              </div>
              <div class="status-detail mt-3">
                <div
                  class="status-icon-box"
                  :class="{ inactive: !printerIsConnected }"
                >
                  <span
                    :class="[
                      'mdi',
                      printerIsConnected ? 'mdi-usb-port' : 'mdi-usb-port-off'
                    ]"
                  ></span>
                </div>
                <div class="status-text-box">
                  <span class="device-name">{{
                    printerIsConnected ? printerName : "Printer Not Found"
                  }}</span>
                  <span class="device-hint">{{
                    printerIsConnected
                      ? "Ready for printing"
                      : "Connect via USB"
                  }}</span>
                </div>
                <Button
                  :title="printerIsConnected ? 'Configure' : 'Connect'"
                  :className="
                    printerIsConnected
                      ? 'button--transparent no-vertical-padding'
                      : 'button--primary no-vertical-padding'
                  "
                  style="min-width: 90px; height: 32px;"
                  :onClick="connectPrinter"
                />
              </div>
            </div>
          </transition>
        </div>
      </template>
      <template v-slot:footer>
        <div class="modal-footer-actions">
          <Button
            title="Close"
            className="button--primary"
            :onClick="() => $modal.hide('printerSettings')"
          />
        </div>
      </template>
    </AppModal>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Button from "@/components/Button";
import DropdownMenu from "@/components/DropdownMenu";
import Input from "@/components/Input";
import Radio from "@/components/Radio";
import Modal from "@/components/Modal";
import Select from "@/components/Select";
import TablePrint from "@/components/TablePrint";
import PrintTable from "@/components/PrintTable";
import ExternalInvoice from "@/components/externalInvoice";
import { mapGetters, mapActions } from "vuex";
import { api } from "@/axios";
import moment from "moment";
import printDiv from "@/utils/print";
import AttachmentUpload from "@/components/AttachmentUpload";
import ThermalPrintService from "@/utils/ThermalPrintService";
import {
  formatGender,
  getGender,
  dateFromNow,
  formatedDate,
  getBranchLogo,
  sumRows
} from "@/utils/helpers";
import resizeImage from "@/utils/resizeImage";
import { formatDateTime } from "../../utils/helpers";
import { permissionsMiddleWare } from "../../utils/permissionsMiddleWare";
import { syncRouteQuery } from "@/utils/urlQueryFilters";
import Loader from "../../components/Loader.vue";

export default {
  components: {
    DataTable,
    DropdownMenu,
    AttachmentUpload,
    TablePrint,
    PrintTable,
    ExternalInvoice,
    Select,
    Radio,
    Input,
    Modal,
    Button,
    Loader,
    AppModal: Modal
  },
  data() {
    return {
      user: {},
      userId: "",
      referredBy: "",
      refferedTo: "",
      registrationId: "",
      discount: null,
      historyId: "",
      patinetId: "",
      files: [],
      isLoading: false,
      isUpdating: false,
      editHistoryId: null,
      editRowData: null,
      filters: {},
      selectedDoctor: null,
      alreadyReported: null,
      id: "",
      options: [
        { id: "male", for: "male", label: "Male" },
        { id: "female", for: "female", label: "Female" }
      ],
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Name", sortable: true },
        {
          column: "fatherOrHusbandName",
          label: "Faher/Husband Name",
          sortable: true
        },
        { column: "contactNumber", label: "Phone Number", sortable: true },
        { column: "service_name", label: "Service", sortable: true },
        {
          column: "historyStatus",
          label: "Progress",
          sortable: true,
          historyStatus: true
        },
        { column: "mr_no", label: "MR Number", sortable: true },
        { column: "created_time", label: "Created At", sortable: true },
        { column: "action", label: "Action" }
      ],
      activeTab: "today",
      printerIsConnected: false,
      printerName: "",
      printDetailsData: null,
      printPatientCopy: true,
      printOfficialCopy: false,
      pendingA4AfterThermal: false,
      a4PrescriptionOnly: false,
      a4PrintPatient: null,
      printerType: localStorage.getItem("printer_type") || "Thermal",
      bussinessLogoUrl: "",
      branchLogoUrl: ""
    };
  },
  methods: {
    ...mapActions("receptionist", [
      "listPatients",
      "patientDetails",
      "updateDetails",
      "cancelAppointment",
      "searchTodayList",
      "laterDiscount",
      "listDoctors",
      "listHistory",
      "printInvoice"
    ]),
    ...mapActions("doctors", ["doctorList", "listRefferedByDoctors"]),
    ...mapActions("expenses", ["fetchBranch", "currentSelectBranch"]),
    ...mapActions("auth", ["uploadAttachment", "resetUploadProgress"]),
    formatDate(date) {
      return formatDateTime(date);
    },
    getUnitPrice(item) {
      return Number(item?.rate ?? item?.amount ?? item?.charge?.amount ?? 0);
    },
    getLineAmount(item) {
      const quantity = Number(item?.quantity ?? 1);
      return this.getUnitPrice(item) * quantity;
    },
    onThermalPrinterMockChanged(event) {
      const { connected, name } = event.detail || {};
      this.printerIsConnected = Boolean(connected);
      this.printerName = name || "";
    },
    savePrinterType() {
      localStorage.setItem("printer_type", this.printerType);
      this.$toasted
        .success(`Printer type set to ${this.printerType}`)
        .goAway(3000);
      if (this.printerType === "Thermal") {
        this.checkPrinterConnection();
      }
    },
    async checkPrinterConnection() {
      const thermalService = ThermalPrintService.getInstance();
      if (thermalService.isMockMode()) {
        await thermalService.autoConnect();
        this.printerIsConnected = thermalService.isConnected;
        this.printerName = thermalService.deviceName;
        return;
      }
      if (thermalService.isSupported()) {
        try {
          const devices = await navigator.usb.getDevices();
          if (devices.length > 0) {
            this.printerIsConnected = true;
            this.printerName = devices[0].productName || "USB Printer";
          } else {
            await thermalService.autoConnect();
            this.printerIsConnected = thermalService.isConnected;
            this.printerName = thermalService.deviceName;
          }
        } catch (err) {
          console.warn("[ThermalPrint] Silent connection check failed:", err);
        }
      }
    },
    async resolveInvoiceNo() {
      const row = this.editRowData || {};
      const candidates = [
        row.invoice_no,
        row.invoice,
        row.invoiceNo,
        row.Invoice_no
      ].filter(Boolean);
      if (candidates.length) return candidates[0];

      const historyFromDetails = (this.detailsPatient?.histories || []).find(
        item => String(item.id) === String(this.editHistoryId)
      );
      if (historyFromDetails?.invoice_no) {
        return historyFromDetails.invoice_no;
      }

      if (this.id) {
        await this.listHistory(this.id);
        const historyItem = (this.getHistory || []).find(
          item => String(item.id) === String(this.editHistoryId)
        );
        if (historyItem?.invoice_no) return historyItem.invoice_no;
      }

      return null;
    },
    hydrateInvoiceFromPatientHistory() {
      const matchHistory = histories =>
        (histories || []).find(
          item => String(item.id) === String(this.editHistoryId)
        );

      const row = this.editRowData || {};
      let history =
        matchHistory(this.detailsPatient?.histories) ||
        matchHistory(this.getHistory);

      if (!history?.charge) {
        if (!history && !row.service_name) return false;
        history = {
          ...(history || { id: this.editHistoryId }),
          invoice_no: history?.invoice_no || row.invoice_no || row.invoice,
          charge: {
            amount:
              history?.charge?.amount ||
              row.amount ||
              row.rate ||
              row.price ||
              0,
            service: {
              name:
                history?.charge?.service?.name ||
                row.service_name ||
                row.service ||
                "Service"
            }
          },
          discount: history?.discount || row.discount || 0,
          quantity: history?.quantity || 1,
          created_at: history?.created_at || row.created_at,
          isOther: row.isother,
          isGenAppt: row.is_general_appointment
        };
      }

      const patient = this.detailsPatient || {};
      this.$store.commit("receptionist/setInvoice", {
        name: patient.name || row.name,
        mr_no: patient.mr_no || row.mr_no,
        mrNo: patient.mr_no || row.mr_no,
        age: patient.age || row.age,
        gender: patient.gender,
        fatherOrHusbandName:
          patient.fatherOrHusbandName || row.fatherOrHusbandName,
        refferedBy: patient.referredBy || row.referredBy,
        histories: [history]
      });
      return true;
    },
    async ensurePrintInvoiceLoaded() {
      if (this.id && !(this.detailsPatient?.histories || []).length) {
        await this.patientDetails(this.id);
      }

      const invoiceNo = await this.resolveInvoiceNo();
      if (invoiceNo) {
        try {
          await this.printInvoice({
            invoice_no: invoiceNo,
            patiantId: this.id
          });
          if (this.invoice?.histories?.length) return true;
        } catch (error) {
          console.error(
            "printInvoice failed, using patient history fallback",
            error
          );
        }
      }

      if (!this.getHistory?.length && this.id) {
        await this.listHistory(this.id);
      }

      return this.hydrateInvoiceFromPatientHistory();
    },
    buildThermalData(rowData = {}) {
      const histories = this.invoice?.histories || [];
      const grossTotal = histories.reduce(
        (sum, item) => sum + this.getLineAmount(item),
        0
      );
      const totalDiscount = histories.reduce(
        (sum, item) => sum + (item.discount || 0),
        0
      );
      const netTotal = grossTotal - totalDiscount;
      const isRadiology = this.printServiceType === "Radiology";
      const isTenant1 = this.userInfo?.tenantId === 1;

      return {
        apiResponse: this.invoice,
        rowData,
        printOptions: {
          dualLogo: isTenant1 && isRadiology
        },
        thermalData: {
          organizationName: this.userInfo?.bussiness?.name || "Family Hospital",
          mrNo: this.invoice.mrNo || rowData.mr_no || this.invoice.mr_no,
          token:
            this.invoiceRows?.[0]?.token ||
            this.invoice?.histories?.[0]?.token ||
            "-",
          serviceHeader:
            this.invoiceRows?.[0]?.service ||
            (this.printServiceType === "Radiology"
              ? "ULTRASOUND"
              : (this.printServiceType || "").toUpperCase()),
          patientName:
            this.invoice.name || this.invoice.patientname || rowData.name,
          fatherHusbandName:
            this.invoice.fatherOrHusbandName ||
            this.invoice.father_husband_name ||
            rowData.fatherOrHusbandName ||
            rowData.father_husband_name ||
            "-",
          age: this.invoice.age || rowData.age,
          gender: this.invoicePatientGender,
          invoiceNo: rowData.invoice || rowData.invoice_no || this.invoiceNo,
          date: moment(
            this.invoice?.histories?.[0]?.created_at ||
              rowData.created_at ||
              new Date()
          ).format("DD/MM/YYYY"),
          referredBy:
            this.invoice.refferedBy ||
            rowData.referred_by ||
            rowData.referredBy ||
            "-",
          panelName: this.invoice.panel_name || rowData.panel_name || null,
          invoiceStatus:
            this.invoice?.histories?.[0]?.invoice_status ||
            rowData.invoice_status,
          rows: histories.map(item => ({
            service: (
              item.service ||
              item.name ||
              item.charge?.service?.name ||
              ""
            ).toUpperCase(),
            price: this.getUnitPrice(item),
            subtotal: this.getLineAmount(item)
          })),
          total: grossTotal,
          discount: totalDiscount,
          netTotal: netTotal,
          printedBy: this.userInfo?.full_name || "Staff",
          printDate: moment(
            this.invoice?.histories?.[0]?.created_at ||
              rowData.created_at ||
              new Date()
          ).format("dddd, MMMM Do, YYYY, h:mm:ss a"),
          branch: this.userInfo?.branch?.name || "Main Branch"
        },
        isDoctorAppointment: this.printServiceType === "Doctor"
      };
    },
    async handlePrintAfterEdit() {
      const rowData = this.editRowData || {};
      if (this.printerType === "A4") {
        const isDoctor =
          rowData.is_general_appointment || this.printServiceType === "Doctor";
        await this.printA4Invoice(rowData, {
          prescriptionOnly: isDoctor
        });
        return;
      }

      this.printDetailsData = this.buildThermalData(rowData);
      this.printPatientCopy = true;
      this.printOfficialCopy = false;

      const thermalService = ThermalPrintService.getInstance();
      if (!thermalService.isConnected) {
        await thermalService.autoConnect();
      }
      this.printerIsConnected = thermalService.isConnected;
      this.printerName = thermalService.deviceName;
      this.$modal.show("printConfirmation");
    },
    buildPrintPatient(rowData = {}) {
      const patient = this.detailsPatient || {};
      const inv = this.invoice || {};
      return {
        name: patient.name || inv.name || inv.patientname || rowData.name,
        fatherOrHusbandName:
          patient.fatherOrHusbandName ||
          inv.fatherOrHusbandName ||
          inv.father_husband_name ||
          rowData.fatherOrHusbandName,
        age: patient.age || inv.age || rowData.age,
        mr_no: patient.mr_no || inv.mr_no || inv.mrNo || rowData.mr_no,
        address: patient.address || inv.address || rowData.address,
        gender: patient.gender || inv.gender
      };
    },
    preloadPrintLogos() {
      const sources = [this.bussinessLogoUrl, this.branchLogoUrl].filter(
        src => typeof src === "string" && src
      );
      return Promise.all(
        sources.map(
          src =>
            new Promise(resolve => {
              const img = new Image();
              img.onload = img.onerror = () => resolve();
              img.src = src;
            })
        )
      );
    },
    async printA4Invoice(rowData = {}, options = {}) {
      const isDoctor =
        rowData.is_general_appointment || this.printServiceType === "Doctor";
      const prescriptionOnly =
        options.prescriptionOnly !== undefined
          ? options.prescriptionOnly
          : isDoctor;

      this.a4PrescriptionOnly = Boolean(prescriptionOnly && isDoctor);
      this.a4PrintPatient = this.buildPrintPatient(rowData);

      await this.fetchBranch();
      const branchId =
        this.invoice?.histories?.[0]?.branchId || this.userInfo?.userBranchId;
      if (branchId && this.fetchUserBranch) {
        const logo = getBranchLogo(this.fetchUserBranch, branchId);
        if (typeof logo === "string" && logo) {
          this.branchLogoUrl = logo;
          this.currentSelectBranch(logo);
        }
      }
      this.bussinessLogoUrl = this.userInfo?.bussinessLogoUrl || "";

      await this.preloadPrintLogos();
      await this.$nextTick();
      await this.$nextTick();

      const details = {
        mrNo:
          this.a4PrintPatient?.mr_no ||
          this.invoice?.mr_no ||
          this.detailsPatient?.mr_no ||
          rowData.mr_no,
        invoiceNo: this.invoiceNo
      };

      if (isDoctor) {
        printDiv("externalInvoice", details);
      } else {
        this.a4PrescriptionOnly = false;
        printDiv("rePrintInvoice", details);
      }
    },
    async triggerPrintAfterEdit() {
      try {
        const loaded = await this.ensurePrintInvoiceLoaded();
        if (!loaded) {
          this.$toasted
            .info("Invoice data not found — print skipped")
            .goAway(3000);
          return;
        }
        await this.$nextTick();
        await this.handlePrintAfterEdit();
      } catch (error) {
        console.error("Print after edit failed:", error);
        this.$toasted.show("Print could not be started").goAway(3000);
      }
    },
    async connectPrinter() {
      try {
        const thermalService = ThermalPrintService.getInstance();
        const name = await thermalService.requestDevice();
        this.printerIsConnected = true;
        this.printerName = name;
        const label = thermalService.isMockMode()
          ? `Mock printer ready: ${name}`
          : `Printer connected: ${name}`;
        this.$toasted.success(label).goAway(3000);
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          ThermalPrintService.enableMockMode();
          this.printerIsConnected = true;
          this.printerName = "Mock Thermal Printer (Dev)";
          this.$toasted
            .success("Using mock thermal printer (dev mode)")
            .goAway(3000);
          return;
        }
        console.error("Connection failed:", error);
        this.$toasted.error("Failed to connect to printer").goAway(3000);
      }
    },
    async executePrint() {
      if (!this.printDetailsData) return;
      const {
        thermalData,
        printOptions: initialOptions,
        rowData,
        isDoctorAppointment
      } = this.printDetailsData;

      try {
        const thermalService = ThermalPrintService.getInstance();
        const printOptions = {
          printPatient: this.printPatientCopy,
          printOfficial: this.printOfficialCopy,
          dualLogo: initialOptions?.dualLogo || false
        };

        await thermalService.printCustom(
          thermalData,
          this.printServiceType,
          printOptions
        );
        this.$modal.hide("printConfirmation");
        this.printerIsConnected = thermalService.isConnected;

        if (isDoctorAppointment && this.printPatientCopy) {
          await this.printA4AfterThermal();
          return;
        }

        this.printDetailsData = null;
      } catch (error) {
        console.error("Thermal printing failed", error);
        this.$toasted
          .error("Thermal print failed, falling back to A4...")
          .goAway(3000);
        this.$modal.hide("printConfirmation");
        this.printA4Invoice(rowData, { prescriptionOnly: false });
        this.printDetailsData = null;
      }
    },
    skipA4AfterThermal() {
      this.pendingA4AfterThermal = false;
      this.$modal.hide("a4AfterThermal");
      this.printDetailsData = null;
    },
    async printA4AfterThermal() {
      this.pendingA4AfterThermal = false;
      this.$modal.hide("a4AfterThermal");
      await this.printA4Invoice(this.editRowData || {}, {
        prescriptionOnly: true
      });
      this.printDetailsData = null;
    },
    async switchToA4() {
      if (!this.printDetailsData) return;
      const { rowData } = this.printDetailsData;
      this.$modal.hide("printConfirmation");
      await this.printA4Invoice(rowData, {
        prescriptionOnly: this.printServiceType === "Doctor"
      });
      this.printDetailsData = null;
    },
    printReport() {
      const details = {
        imageUrl: this.userInfo && this.userInfo?.bussinessLogoUrl,
        imageUrl2: this.getBranchUrl
      };
      printDiv("todays-list", details);
    },
    handleItems(val, rowData) {
      this.patinetId = rowData.id;
      this.editHistoryId = rowData.historyId;
      if (val == "Edit") {
        this.openEditModal(rowData);
      }
      if (val == "Cancel") {
        const payload = {
          status: 4
        };
        this.cancelAppointment({
          id: rowData.id,
          historyId: rowData.historyId,
          payload
        });
      } else if (val == "Cancel Study") {
        this.laterDiscount({ historyId: rowData.historyId }).then(() => {
          this.$toasted.success("Cancel study successfully").goAway("3000");
        });
      } else if (val == "Discount") {
        this.editHistoryId = rowData.historyId;
        this.$modal.show("discountModal");
      } else if (val == "Add Attachment") {
        this.$modal.show("attachment");
      } else if (val == "View Attachment") {
        this.patientDetails(rowData.id).then(() => {
          if (this?.attachments?.length) {
            this.imagePopup();
          } else {
            this.$toasted.success("Attachment not available").goAway("3000");
          }
        });
      } else if (val == "Verified") {
        if (permissionsMiddleWare("Get Updated History")) {
          api
            .get(`/history/history-update/${rowData?.historyId}`)
            .then(res => {
              if (res?.data?.result?.affected === 1) {
                this.$toasted.show("Status changed sucessfully").goAway("3000");
              } else {
                this.$toasted.show("Status didn't changed").goAway("3000");
              }
            })
            .catch(() => {
              this.$toasted.show("Status didn't changed").goAway("3000");
            });
        } else {
          this.$toasted.info(
            "This action cannot be performed by you due to insufficient authorization. Action : Get Updated History",
            { duration: 3000 }
          );
        }
      }
    },
    async handleAttachmentUpload(val) {
      if (typeof val === "object") {
        const config = {
          file: val,
          maxSize: 3024
        };
        const resizedImage = await resizeImage(config);
        this.files.push(resizedImage);
      } else {
        for (let index = 0; index < val.length; index++) {
          const file = val[index];
          const config = {
            file,
            maxSize: 2024
          };
          const resizedImage = await resizeImage(config);
          this.files.push(resizedImage);
        }
      }
    },
    getFilterQuery() {
      const query = { tab: this.activeTab };
      if (this.filters.filterId) {
        query.service_head = this.filters.filterId;
      }
      if (this.registrationId) {
        query.mr_no = this.registrationId;
      }
      return query;
    },
    syncFiltersToUrl() {
      syncRouteQuery(this.$router, this.$route, this.getFilterQuery());
    },
    async applyFiltersFromUrl() {
      const { service_head, mr_no, tab } = this.$route.query;

      if (tab === "today" || tab === "yesterday") {
        this.activeTab = tab;
      }

      if (mr_no) {
        this.registrationId = mr_no;
        this.filters.searchVaue = mr_no;
      }

      if (service_head) {
        this.filters.filterId = service_head;
        const doctor = this.filterByOptions?.find(
          item => String(item.id) === String(service_head)
        );
        if (doctor) {
          this.selectedDoctor = doctor;
        }
      }

      if (mr_no) {
        await this.searchTodayList(this.filters);
      } else if (service_head) {
        await this.listPatients({ service_head });
      } else {
        await this.listPatients();
      }
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.syncFiltersToUrl();
    },
    handleFilter(val) {
      if (val) {
        this.filters.filterId = val.id;
        this.selectedDoctor = val;
        this.listPatients({ service_head: val.id });
      } else {
        this.selectedDoctor = null;
        this.filters.filterId = undefined;
        this.listPatients();
      }
      this.syncFiltersToUrl();
    },
    async handleUpload() {
      if (this.files) {
        await this.uploadAttachment({
          file: this.files,
          id: this.patinetId,
          vm: this
        }).then(() => {
          this.$modal.hide("attachment");
          this.resetUploadProgress();
          this.files = [];
        });
      }
    },
    handleDiscount() {
      this.laterDiscount({
        historyId: this.editHistoryId,
        discount: this.discount
      })
        .then(() => {
          const { mr_no } =
            this.laterDiscountDetails &&
            this.laterDiscountDetails.patient &&
            this.laterDiscountDetails.patient;
          const { invoice_no } = this.laterDiscountDetails;
          const details = {
            mrNo: mr_no,
            invoiceNo: invoice_no,
            imageUrl: this.userInfo && this.userInfo?.bussinessLogoUrl,
            imageUrl2: this.getBranchUrl
          };
          printDiv("TablePrint", details);
          this.discount = null;
          this.$modal.hide("discountModal");
          this.$toasted.success("Discount added successfully").goAway("3000");
        })
        .catch(() => {
          this.$modal.hide("discountModal");
          this.discount = null;
        });
    },
    imagePopup() {
      const element = this.$refs.element;
      var newTab = window.open();
      setTimeout(function() {
        newTab.document.body.innerHTML = element.innerHTML;
      }, 500);
      return false;
    },
    pageChanged(val) {
      this.listPatients(val);
    },
    handlerefferedBy(val) {
      if (val) {
        this.user.referredBy = val.name;
        this.user.lookupId = val.id;
        this.referredBy = val.name;
      }
    },
    async ensureEditFormOptions() {
      const tasks = [];
      if (!this.refferedByDoctors?.length) {
        tasks.push(
          this.listRefferedByDoctors("doctor"),
          this.listRefferedByDoctors("hospital")
        );
      }
      if (!this.doctorsList?.length) {
        tasks.push(this.listDoctors());
      }
      if (tasks.length) {
        await Promise.all(tasks);
      }
    },
    hydrateDetailsFromRow(rowData = {}) {
      this.$store.commit("receptionist/set_details", {
        id: rowData.id,
        name: rowData.name,
        fatherOrHusbandName: rowData.fatherOrHusbandName,
        contactNumber: rowData.contactNumber,
        age: rowData.age,
        address: rowData.address,
        gender: rowData.gender,
        referredBy: rowData.referredBy,
        mr_no: rowData.mr_no,
        userId: rowData.userId,
        user: rowData.user
      });
    },
    syncEditFormFields(rowData = {}) {
      const val = this.detailsPatient || {};
      this.userId = val.userId || rowData.userId;
      this.refferedTo =
        (val.user && val.user.employ && val.user.employ.full_name) ||
        rowData.referredTo ||
        rowData.refferedTo ||
        "";
      this.referredBy = val.referredBy || rowData.referredBy || "";
    },
    async openEditModal(rowData) {
      this.editRowData = rowData;
      this.id = rowData.id;
      this.editHistoryId = rowData.historyId;
      this.alreadyReported = rowData.ischild;
      this.patinetId = rowData.id;

      try {
        await this.ensureEditFormOptions();
        await this.patientDetails(rowData.id);
        if (!this.detailsPatient?.name) {
          this.hydrateDetailsFromRow(rowData);
        }
        this.syncEditFormFields(rowData);
        this.$modal.show("patientDetails");
      } catch (error) {
        console.error("Failed to load patient for edit:", error);
        this.hydrateDetailsFromRow(rowData);
        this.syncEditFormFields(rowData);
        this.$modal.show("patientDetails");
      }
    },
    async updatePatient() {
      this.isUpdating = true;
      this.user.userId = this.userId;
      try {
        await this.updateDetails({
          id: this.id,
          user: this.user,
          historyId: this.editHistoryId
        });
        await this.patientDetails(this.id);
        if (this.filters.filterId) {
          await this.listPatients({ service_head: this.filters.filterId });
        } else if (this.filters.searchVaue) {
          await this.searchTodayList(this.filters);
        } else {
          await this.listPatients();
        }
        this.$store.dispatch("reports/patientDailyReport", {
          end_date: formatedDate(),
          start_date: formatedDate()
        });
        this.$toasted.success("Patient updated successfully").goAway("3000");
        this.$modal.hide("patientDetails");
        this.isUpdating = false;
        await this.$nextTick();
        await this.triggerPrintAfterEdit();
      } catch (error) {
        this.isUpdating = false;
      }
    },
    handleRefferedTo(val) {
      this.userId = val.id;
      this.refferedTo = val.name;
    },
    handleSearch() {
      this.filters.searchVaue = this.registrationId;

      this.searchTodayList(this.filters);
      this.syncFiltersToUrl();
    },
    handleReset() {
      this.registrationId = "";
      this.selectedDoctor = null;
      this.filters = {};
      this.listPatients().then(() => {
        this.syncFiltersToUrl();
      });
    }
  },
  computed: {
    ...mapGetters({
      doctors: "services/charges",
      patientList: "receptionist/patientList",
      // isLoading: "receptionist/isLoading",
      detailsPatient: "receptionist/detailsPatient",
      doctorsList: "receptionist/doctorsList",
      discountLater: "receptionist/discountLater",
      refferedByDoctors: "doctors/refferedByDoctors",
      listDoctors: "doctors/listDoctors",
      userInfo: "auth/userInfo",
      loading: "loading",
      selectedBranch: "expenses/selectedBranch",
      invoice: "receptionist/invoice",
      getHistory: "receptionist/getHistory",
      fetchUserBranch: "expenses/fetchUserBranch"
    }),
    getBranchUrl() {
      return this.selectedBranch;
    },
    invoiceNo() {
      return this.invoice?.histories?.[0]?.invoice_no;
    },
    invoiceRows() {
      const histories = this.invoice?.histories || [];
      return histories.map(item => ({
        discountValue: item.discount === 0 ? "" : item.discount,
        quantityNumber: item.quantity,
        price: this.getUnitPrice(item),
        subtotal: this.getLineAmount(item) - (item?.discount || 0),
        createdDate: item?.created_at,
        ...item.charge?.service,
        token: item.token,
        service: item?.charge?.service?.lookup?.name || "TOKEN"
      }));
    },
    invoiceSubtotal() {
      const histories = this.invoice?.histories || [];
      const amounts = histories.map(item => this.getLineAmount(item));
      return sumRows(amounts) - this.invoiceDiscountAmount;
    },
    invoiceDiscountAmount() {
      const histories = this.invoice?.histories || [];
      const discounts = histories.map(item => item.discount || 0);
      return sumRows(discounts);
    },
    invoicePatientGender() {
      return formatGender(this.invoice?.gender);
    },
    printServiceType() {
      const row = this.editRowData || {};
      if (row.is_general_appointment) return "Doctor";
      const histories = this.invoice?.histories || [];
      if (histories.some(item => item.isGenAppt)) return "Doctor";
      if (row.isother === 0 || histories.some(item => item.isOther == 0)) {
        return "Radiology";
      }
      return "Other";
    },
    printSearchResult() {
      return this.detailsPatient || {};
    },
    printRefferedTo() {
      const raw =
        this.refferedTo ||
        this.invoice?.refferedTo ||
        this.editRowData?.referredTo;
      if (raw && typeof raw === "object") return raw;
      const matched = (this.refferedDoctor || []).find(
        item => item.name === raw
      );
      return matched || { name: raw || "" };
    },
    refferedDoctor() {
      return (
        this.doctorsList &&
        this.doctorsList.map(item => ({
          name: item.full_name,
          id: item.id
        }))
      );
    },
    filterByOptions() {
      let options = [];
      const isTech = this.userInfo.userRole.some(
        item => item.name === "technician"
      );
      if (isTech) {
        options =
          this.listDoctors &&
          this.listDoctors.filter(
            item => item.name === "MRI" || item.name === "CT"
          );
      } else {
        options = this.listDoctors;
      }
      return options;
    },
    attachments() {
      return this?.detailsPatient?.attachment || [];
    },
    todayList() {
      const isTech = this.userInfo.userRole.some(
        item => item.name === "technician"
      );
      let patientData = [];
      const filterArr =
        this.patientList &&
        this.patientList.filter(item => {
          const date = formatedDate(item.created_at);
          return moment(date).isSame(formatedDate());
        });
      if (isTech) {
        patientData = filterArr.filter(item => item.isother === 0);
      } else {
        patientData = filterArr;
      }
      return patientData.map(item => ({
        ...item,
        created_time: dateFromNow(item.created_at)
      }));
    },
    yesterdayList() {
      const isTech = this.userInfo.userRole.some(
        item => item.name === "technician"
      );
      let patientData = [];
      const filterArr =
        this.patientList &&
        this.patientList.filter(item => {
          const date = formatedDate(item.created_at);
          return moment(date).isBefore(formatedDate());
        });
      if (isTech) {
        patientData = filterArr.filter(item => item.isother === 0);
      } else {
        patientData = filterArr;
      }
      return patientData.map(item => ({
        ...item,
        created_time: dateFromNow(item.created_at)
      }));
    },
    userDetails() {
      return this.detailsPatient || {};
    },
    fullName: {
      get() {
        return this.userDetails.name;
      },
      set(val) {
        this.user.name = val;
      }
    },
    fatherHusband: {
      get() {
        return this.userDetails.fatherOrHusbandName;
      },
      set(val) {
        this.user.fatherOrHusbandName = val;
      }
    },
    age: {
      get() {
        return this.userDetails.age;
      },
      set(val) {
        this.user.age = val;
      }
    },
    address: {
      get() {
        return this.userDetails.address;
      },
      set(val) {
        this.user.address = val;
      }
    },
    userGender: {
      get() {
        return formatGender(this.userDetails && this.userDetails.gender);
      },
      set(val) {
        this.user.gender = getGender(val);
      }
    },
    phone: {
      get() {
        return this.userDetails && this.userDetails.contactNumber;
      },
      set(val) {
        this.user.contactNumber = val;
      }
    },
    laterDiscountDetails() {
      const arr =
        Array.isArray(this.discountLater) && this.discountLater.length > 0
          ? this.discountLater
          : [];
      const [newArr] = [...arr];
      return newArr;
    },
    totalAmount() {
      const discount =
        this.laterDiscountDetails && this.laterDiscountDetails.discount;
      const total =
        this.laterDiscountDetails &&
        this.laterDiscountDetails &&
        this.laterDiscountDetails.charge &&
        this.laterDiscountDetails.charge.amount;
      return total - discount;
    },
    serviceRows() {
      const item =
        (this.laterDiscountDetails &&
          this.laterDiscountDetails.charge &&
          this.laterDiscountDetails.charge.service) ||
        {};
      const amount =
        this.laterDiscountDetails &&
        this.laterDiscountDetails.charge &&
        this.laterDiscountDetails.charge.amount;
      const items = [];
      items.push({
        name: item && item.name,
        price: amount,
        subtotal: amount
      });
      return items;
    },
    items() {
      const arr = [
        "Edit",
        "Cancel",
        "Cancel Study",
        "Discount",
        "Add Attachment",
        "View Attachment"
      ];
      const role = this.userInfo.userRole.find(item => item);
      if (role.name === "technician") {
        arr.push("Verified");
      }
      return arr;
    }
  },
  watch: {
    userDetails(val) {
      this.userId = val.userId;
      this.refferedTo =
        val.user && val.user.employ && val.user.employ.full_name;
      this.referredBy = val.referredBy;
    }
  },
  async mounted() {
    const patientsPromise = this.applyFiltersFromUrl();
    await Promise.all([
      patientsPromise,
      this.doctorList(),
      this.listDoctors(),
      this.listRefferedByDoctors("doctor"),
      this.listRefferedByDoctors("hospital")
    ]);
    await this.fetchBranch();
    this.bussinessLogoUrl = this.userInfo?.bussinessLogoUrl || "";
    const branchId = this.userInfo?.userBranchId;
    if (branchId && this.fetchUserBranch) {
      const logo = getBranchLogo(this.fetchUserBranch, branchId);
      if (typeof logo === "string" && logo) {
        this.branchLogoUrl = logo;
        this.currentSelectBranch(logo);
      }
    }
    if (this.printerType === "Thermal") {
      this.checkPrinterConnection();
    }
    window.addEventListener(
      "thermal-printer-mock-changed",
      this.onThermalPrinterMockChanged
    );
  },
  beforeDestroy() {
    window.removeEventListener(
      "thermal-printer-mock-changed",
      this.onThermalPrinterMockChanged
    );
  }
};
</script>

<style>
@import "../../assets/css/print.css";

#list {
  padding: 0 1rem;
}

#list .form-wrrpper > div {
  flex: 0 0 30%;
  max-width: 30%;
}

.list-search {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.attachment-modal .custom-modal .modal-header .modal-heading h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  color: #555555;
}

.attachment-modal .custom-modal .modal-header {
  align-items: unset;
  padding-bottom: 0;
  border-bottom: none;
}

.custom-modal > .vm--modal {
  overflow: visible !important;
}

.attachment-modal .modal-header p {
  margin-top: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.05em;
  color: #8d8d8d;
}

@media only screen and (max-width: 1366px) {
  #list .mr-4 {
    margin-right: 40px !important;
  }
}

#TablePrint {
  display: none !important;
}

#rePrintInvoice,
#externalInvoice {
  display: none !important;
}

@media print {
  #TablePrint {
    display: block !important;
  }

  #rePrintInvoice,
  #externalInvoice {
    display: block !important;
  }
}

.tabs-container {
  background: #fff;
  border-radius: 8px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 1rem;
}

.tab {
  padding: 0.75rem 2rem;
  cursor: pointer;
  font-weight: 600;
  color: #888;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-bottom 0.2s;
  position: relative;
}

.tab.active {
  color: #1976d2;
  border-bottom: 2px solid #1976d2;
  background: #f7faff;
}

.badge {
  background: #1976d2;
  color: #fff;
  border-radius: 12px;
  padding: 0 8px;
  font-size: 0.85em;
  margin-left: 0.5em;
}

.tab-content {
  padding: 0.5rem 0;
}

.print-modal-content {
  padding: 0;
}

.printer-status-bar {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  border-bottom: 1px solid var(--line);
}

.printer-status-bar.connected {
  background: var(--surface-2);
  color: var(--success);
}

.printer-status-bar.disconnected {
  background: var(--surface-2);
  color: var(--warning);
}

.printer-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.printer-label {
  font-weight: 600;
  font-size: var(--fs-body);
}

.printer-name {
  font-size: var(--fs-xs);
  opacity: 0.8;
}

.print-options {
  padding: 16px;
}

.options-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 12px;
}

.print-option {
  display: flex;
  align-items: center;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
  background: var(--surface-2);
}

.print-option:hover {
  border-color: var(--accent-500);
  background: var(--surface);
}

.print-option.selected {
  border-color: var(--accent-600);
  background: var(--accent-050);
}

.option-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 12px;
}

.option-icon.patient {
  background: var(--accent-050);
  color: var(--accent-600);
}

.option-icon.official {
  background: var(--surface-2);
  color: var(--muted);
}

.option-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.option-label {
  font-weight: 600;
  font-size: var(--fs-body);
  color: var(--text);
}

.option-desc {
  font-size: var(--fs-xs);
  color: var(--muted-soft);
}

.option-check {
  font-size: 22px;
}

.print-option.selected .option-check {
  color: var(--accent-600);
}

.print-option:not(.selected) .option-check {
  color: var(--line-strong);
}

.print-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  background: var(--surface-2);
}

.a4-link {
  font-size: var(--fs-xs);
  color: var(--accent-600);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.footer-buttons {
  display: flex;
  gap: 8px;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: var(--radius-sm);
  font-size: var(--fs-sm);
  color: var(--text);
  cursor: pointer;
}

.btn-print {
  padding: 8px 20px;
  border: none;
  background: var(--grad-accent);
  color: #fff;
  border-radius: var(--radius-sm);
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-print:disabled {
  background: var(--line-strong);
  cursor: not-allowed;
}

.button--xs {
  padding: 4px 10px;
  font-size: var(--fs-xs);
}

.printer-settings-modal-body {
  padding: 1.5rem;
}

.section-title {
  font-weight: 700;
  font-size: var(--fs-h2);
  margin-bottom: 1.5rem;
  color: var(--ink-900);
}

.printer-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
}

.sel-card {
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  padding: 1rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;
  background: var(--surface);
}

.sel-card.active {
  border-color: var(--accent-600);
  background: var(--accent-050);
  box-shadow: var(--shadow-sm);
}

.sel-card-icon {
  width: 40px;
  height: 40px;
  background: var(--surface-2);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.sel-card.active .sel-card-icon {
  background: var(--accent-600);
  color: #fff;
}

.sel-card-content h6 {
  margin: 0 0 0.25rem 0;
  font-weight: 700;
  font-size: var(--fs-body);
}

.sel-card-content p {
  margin: 0;
  font-size: var(--fs-xs);
  color: var(--muted);
}

.sel-card-radio {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.radio-circle {
  width: 20px;
  height: 20px;
  border: 2px solid var(--line-strong);
  border-radius: 50%;
}

.sel-card.active .radio-circle {
  border-color: var(--accent-600);
}

.sel-card.active .radio-circle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background: var(--accent-600);
  border-radius: 50%;
}

.printer-status-block {
  border-top: 1px solid var(--line);
  padding-top: 1.5rem;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: var(--fs-xs);
  font-weight: 600;
}

.status-detail {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: var(--surface-2);
  padding: 1rem;
  border-radius: var(--radius-md);
}

.status-icon-box {
  width: 40px;
  height: 40px;
  background: var(--surface);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: var(--accent-600);
}

.status-icon-box.inactive {
  color: var(--muted);
}

.status-text-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.device-name {
  font-weight: 600;
  font-size: var(--fs-sm);
}

.device-hint {
  font-size: var(--fs-xs);
  color: var(--muted);
}
</style>
